import React, { useState, useEffect, useRef } from "react";
import "./OrgStructure.css";
import ExecutiveLeadershipTeam from "./ExecutiveLeadershipTeam";
import StrategicLeadershipThemes from "./StrategicLeadershipThemes";
import TopRightActionLinks from "../../TopRightActionLinks";
import BusinessSegmentStructure from "./BusinessSegmentStructure";
import GenericOverviewSideCard from "../../../genericComponents/GenericOverviewSideCard";
import AIChat from "../../../Chat/AiChat";
import { useParams } from "react-router-dom";
import { useUser } from "../../../../../context/UserContext";
import APP_CONFIG from "../../../../../config/appConfig";
import { useDispatch, useSelector } from "react-redux";
import { submitCompetitorProfileV3Request } from "../../../../../store/features/actions/competitorProfileV3Actions";
import {
  formatBoldText,
  getAllSubdimensionMatches,
  getAllDynamicSubdimensionMatches,
  getCompProfilePageInsights,
  transformOrgChartData,
} from "../../../../../services/commonService";
import useDynamicSubtabs from "../../../../../hooks/useDynamicSubtabs";
import useDynamicTableExport from "../../../../../hooks/useDynamicTableExport";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";
import FutureBets from "./FutureBets";
import OrgChartGiq from "./OrgChartGiq";
import Timeline from "./Timeline";
import GenericTableSkeleton from "../../../skeletons/tableSkeleton/genericTableSkeleton";
import InputView from "../../../../../components/input/InputView";
// import OrgChartView from "./OrgChartView";
import OrgChartView from "../../../../../components/views/OrgChartView";

// --- NEW JSON IMPORTS START ---
import bostikHierarchy from "../../../../../vp_level_jsons/Bostik.json";
import useActiveScrollSection from "../../../../../hooks/useActiveScrollSection";
import * as FeatherIcon from "react-feather";
// import hbFullerHierarchy from "../../../../../vp_level_jsons/H B Fuller.json";
// import henkelHierarchy from "../../../../../vp_level_jsons/Henkel.json";

// A reusable view for displaying loading/error messages
const MessageView = ({ message }) => (
  <div className="full-page-centered">
    <div className="input-container">
      <h2>Organizational Analysis</h2>
      <p className="input-subtitle">{message}</p>
    </div>
  </div>
);

function OrgStructure({
  activeSubKey,
  setActiveSubKey,
  dataReportCheck,
  scrollTarget,
  existingSubdimensions,
  subdimensionStatus,
  registerDynamicTabs,
}) {
  const { user } = useUser();
  const { exportTableToCSV } = useDynamicTableExport();
  const executiveTimelineRef = useRef(null);
  const executiveLeadershipTeamRef = useRef(null);
  const organizationalHierarchyRef = useRef(null);
  // const businessSegmentStructureRef = useRef(null);
  const strategicLeadershipThemesRef = useRef(null);
  const futureBetsLeadershipLedInitiativesRef = useRef(null);
  const programmaticScrollRef = useRef(false);
  const dynamicRefs = useRef({}); // For dynamic sections
  const containerRef = useRef(null);
  const [dynamicReady, setDynamicReady] = useState(0);
  //////////////////////////////////////////////////////////////
  // [START] => NEW ORG STRUCTURE CODE
  const [isLoading, setIsLoading] = useState(false);
  const [errorO, setErrorO] = useState(null);
  const [companyData, setCompanyData] = useState(null);
  const [viewMode, setViewMode] = useState("hierarchy");

  const [dynamicSubdimension, setDynamicSubdimension] = useState([]);
  useDynamicSubtabs({
    parentKey: "orgStructure",
    sourceData: dynamicSubdimension,
    registerDynamicTabs,
    keyPrefix: "dynamic_org_structure",
  });

  // ++++++++++++++++++++++++++++++++++++++++++++++
  const subdimensionExists = (key) => {
    if (!existingSubdimensions || existingSubdimensions.length === 0) {
      return true; // fallback if backend doesn't send list
    }

    return existingSubdimensions.includes(key);
  };

  const subdimensionEnabled = (key) => {
    if (!subdimensionStatus) return true;

    return subdimensionStatus[key] !== false;
  };
  // ++++++++++++++++++++++++++++++++++++++++++++++
  // const [showChartView, setShowChartView] = useState(false);

  // --- Rendering Logic ---

  // if (isLoading) {
  //   return (
  //     <MessageView
  //       message={`Loading organizational data for ${competitorName}...`}
  //     />
  //   );
  // }

  // if (error) {
  //   return <MessageView message={error} />;
  // }
  // const handleAnalysis = async (companyName) => {
  //   // setIsLoading(true);
  //   setErrorO(null);
  //   setCompanyData(null);
  //   setShowChartView(false);

  //   // --- REPLACED API CALL WITH LOCAL DATA LOADING LOGIC ---

  //   try {

  //     // Simulate a network delay for better UX
  //     await new Promise((resolve) => setTimeout(resolve, 500));

  //     let hierarchyData;
  //     const normalizedName = companyName.toLowerCase().replace(/\s/g, "");

  //     if (normalizedName.includes("bostik")) {
  //       hierarchyData = bostikHierarchy;
  //     } else if (
  //       normalizedName.includes("hbfuller") ||
  //       normalizedName.includes("h.b.fuller")
  //     ) {
  //       hierarchyData = hbFullerHierarchy;
  //     } else if (normalizedName.includes("henkel")) {
  //       hierarchyData = henkelHierarchy;
  //     } else {
  //       throw new Error(
  //         `No local data found for company: "${companyName}". Try "Bostik", "H B Fuller", or "Henkel".`
  //       );
  //     }

  //     setCompanyData({
  //       rawHierarchyData: hierarchyData,
  //       rawLeadershipData: leadersData,
  //     });
  //   } catch (err) {
  //     console.error("Local Data Load failed:", err);

  //     setErrorO(err.message || String(err));
  //     setCompanyData(null);
  //   } finally {
  //     // setIsLoading(false);
  //   }
  // };

  // const handleShowView = () => {
  //   setShowChartView(true);
  // };

  // const handleNewSearch = () => {
  //   setCompanyData(null);
  //   setShowChartView(false);
  //   setErrorO(null);
  // };
  // [END] => NEW ORG STRUCTURE CODE
  //////////////////////////////////////////////////////////////

  const sectionMap = {
    executiveTimelineTab: executiveTimelineRef,
    executiveLeadershipTeamTab: executiveLeadershipTeamRef,
    organizationalHierarchyTab: organizationalHierarchyRef,
    // businessSegmentStructureTab: businessSegmentStructureRef,
    // strategicLeadershipThemesTab: strategicLeadershipThemesRef,
    futureBetsLeadershipLedInitiativesTab:
      futureBetsLeadershipLedInitiativesRef,
    ...Object.fromEntries(
      Object.entries(dynamicRefs.current).map(([key, el]) => [
        key,
        { current: el },
      ])
    ),
  };

  // useActiveScrollSection(
  //   sectionMap,
  //   activeSubKey,
  //   setActiveSubKey,
  //   programmaticScrollRef
  // );

  const { showScrollTop, scrollToTop } = useActiveScrollSection(
    sectionMap,
    activeSubKey,
    setActiveSubKey,
    programmaticScrollRef,
    dynamicReady, // NEW
    containerRef // NEW
  );

  // const scrollToSection = (key) => {
  //   const ref = sectionMap[key];
  //   if (!ref?.current) return;

  //   programmaticScrollRef.current = true;

  //   const yOffset = -100;
  //   const y =
  //     ref.current.getBoundingClientRect().top + window.scrollY + yOffset;

  //   window.scrollTo({ top: y, behavior: "smooth" });

  //   setTimeout(() => {
  //     programmaticScrollRef.current = false;
  //   }, 700);
  // };

  const scrollToSection = (key) => {
    const staticRef = sectionMap[key];

    if (staticRef?.current) {
      staticRef.current.scrollIntoView({
        behavior: "instant",
        block: "start",
      });
      return;
    }

    const dynamicEl = dynamicRefs.current[key];

    if (dynamicEl) {
      dynamicEl.scrollIntoView({
        behavior: "instant",
        block: "start",
      });
    }
  };

  const [showConversationModal, setShowConversationModal] = useState(false);
  const { clientName, competitorName } = useParams();
  const [executiveLeadershipTeam, setExecutiveLeadershipTeam] = useState([]);
  // const [strategicLeadershipThemes, setStrategicLeadershipThemes] = useState(
  //   []
  // );
  const [futureBets, setFutureBets] = useState([]);
  // const [businessSegmentStructure, setBusinessSegmentStructure] = useState([]);
  const [orgChartData, setOrgChartData] = useState([]);
  const [pagePositives, setPagePositives] = useState([]);
  const [pageNegatives, setPageNegatives] = useState([]);
  const [pageSoWhat, setPageSoWhat] = useState([]);
  const [orgStructureDataCheck, setOrgStructureDataCheck] = useState({
    hasExecutiveTimelineTabData: true,
    hasExecutiveLeadershipTeamTabData: true,
    hasOrganizationalHierarchyTabData: true,
    // hasBusinessSegmentStructureTabData: true,
    // hasStrategicLeadershipThemesTabData: true,
  });

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    // {
    //   type: "conversation",
    //   title: "Conversation",
    //   onClick: () => {
    //     setShowConversationModal((prev) => !prev);
    //   },
    // },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    // { type: "download", title: "Download", onClick: () => {} },
  ];

  const TIMELINE_DATA = [
    {
      date: "Oct 2023",
      title: "Jim Boyle appointed CEO, succeeding Charlie Mills.",
      description:
        "This marks a generational leadership shift after decades of family ownership.",
      category: "Leadership Transition",
    },
    {
      date: "Nov 2023",
      title: "Steve Miller to become COO.",
      description:
        "This initiative aims to achieve net-zero emissions by 2035.",
      category: "Operational Continuity",
    },
    {
      date: "Dec 2023",
      title: "Amanda Laabs to become Chief Product Officer.",
      description:
        "The collaboration includes internship programs and research funding.",
      category: "Product Innovation Signal",
    },
  ];

  const dispatch = useDispatch();
  const { loading, data, error } = useSelector(
    (state) => state.competitorProfileV3Reducer
  );

  // const v3Data = useSelector((state) => state.competitorProfileV3Reducer);

  const formData = {
    dimension: "OrgStructure",
    client: clientName ?? "HB Fuller",
    company: competitorName ?? "Tailored Chemical Products",
    user_id: user?.user_id,
    user_role: user?.growth_iq_role_name,
    user_type:
      user?.demo === APP_CONFIG?.market_iq_demo ? "MarketIQ" : "CompIQ",
  };

  useEffect(() => {
    dispatch(submitCompetitorProfileV3Request(formData));
  }, []);

  /////////////////////////////////////////////
  // [START] => NEW ORGCHARTVIEW
  useEffect(() => {
    // The data loading logic remains the same, as it depends on the competitor's name
    const loadCompanyData = async (company) => {
      if (!company || company.trim() === "") {
        setErrorO("No organization specified in the URL.");
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      setErrorO(null);
      setCompanyData(null);

      await new Promise((resolve) => setTimeout(resolve, 500));

      try {
        // const module = await import(`../../../../../vp_level_jsons/${company}.json`);
        const module = await import(
          `../../../../../vp_level_jsons/${competitorName}.json`
        );
        const companyInfo = module.default;
        const hierarchyData = companyInfo.hierarchy;
        const filteredLeaders = companyInfo.leaders;

        if (!hierarchyData) {
          throw new Error(`Hierarchy data is missing for "${company}".`);
        }

        if (!filteredLeaders || filteredLeaders.length === 0) {
          console.warn(`No leaders found for company: "${companyInfo.name}".`);
        }

        setCompanyData({
          rawHierarchyData: hierarchyData,
          rawLeadershipData: filteredLeaders,
        });
      } catch (err) {
        // This catch block will now handle both network errors and missing files.
        console.error("Failed to load company data:", err);
        setErrorO(`Organizational data is not available for "${company}".`);
        setCompanyData(null);
      } finally {
        setIsLoading(false);
      }
    };

    // console.log(`Client context: ${clientName}`);

    loadCompanyData(clientName);
  }, [clientName, competitorName]);
  // [END] => NEW ORGCHARTVIEW
  /////////////////////////////////////////////

  // Scroll into view when a subsection tab is clicked
  // useEffect(() => {
  //   if (!activeSubKey) return;
  //   const sectionMap = {
  //     executiveTimelineTab: executiveTimelineRef,
  //     executiveLeadershipTeamTab: executiveLeadershipTeamRef,
  //     organizationalHierarchyTab: organizationalHierarchyRef,
  //     businessSegmentStructureTab: businessSegmentStructureRef,
  //     strategicLeadershipThemesTab: strategicLeadershipThemesRef,
  //     futureBetsLeadershipLedInitiativesTab:
  //       futureBetsLeadershipLedInitiativesRef,
  //   };

  //   const sectionRef = sectionMap[activeSubKey];
  //   if (sectionRef?.current) {
  //     const yOffset = -100;
  //     const y =
  //       sectionRef.current.getBoundingClientRect().top +
  //       window.scrollY +
  //       yOffset;

  //     window.scrollTo({ top: y, behavior: "smooth" });
  //   }
  // }, [activeSubKey]);

  // useEffect(() => {
  //   if (!activeSubKey) return;

  //   const sectionRef = sectionMap[activeSubKey];
  //   if (sectionRef?.current) {
  //     // mark as programmatic scroll so scroll-spy ignores this movement
  //     programmaticScrollRef.current = true;

  //     const yOffset = -100;
  //     const y =
  //       sectionRef.current.getBoundingClientRect().top +
  //       window.scrollY +
  //       yOffset;

  //     window.scrollTo({ top: y, behavior: "smooth" });

  //     // clear the flag after animation; tune timeout to match your animation time
  //     const t = setTimeout(() => {
  //       programmaticScrollRef.current = false;
  //     }, 700);

  //     return () => clearTimeout(t);
  //   }
  // }, [activeSubKey]);

  useEffect(() => {
    if (!activeSubKey) return;
    scrollToSection(activeSubKey);
  }, [activeSubKey]);

  // +++++++++++++++++++++++++++++++++++++++++++++
  // USEEFFECT FOR UPDATING LEFT NAVIGATION LINK ON SCROLL
  // useEffect(() => {
  //   let ticking = false;

  //   const handleScroll = () => {
  //     if (programmaticScrollRef.current) return; // ignore programmatic scrolls
  //     if (ticking) return;
  //     ticking = true;

  //     window.requestAnimationFrame(() => {
  //       const scrollPosition = window.scrollY + 120; // offset to trigger slightly earlier
  //       let currentKey = null;

  //       Object.entries(sectionMap).forEach(([key, ref]) => {
  //         if (!ref.current) return;
  //         const sectionTop = ref.current.offsetTop;
  //         if (scrollPosition >= sectionTop) {
  //           currentKey = key;
  //         }
  //       });

  //       // update parent only if different
  //       if (currentKey && currentKey !== activeSubKey) {
  //         setActiveSubKey(currentKey);
  //       }
  //       ticking = false;
  //     });
  //   };

  //   window.addEventListener("scroll", handleScroll, { passive: true });
  //   // trigger once on mount to set correct nav if already scrolled
  //   handleScroll();

  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, [activeSubKey, setActiveSubKey]);

  // useEffect(() => {
  //   let scrollTimeout = null;
  //   let ticking = false;

  //   const handleScroll = () => {
  //     if (programmaticScrollRef.current) return; // ignore programmatic scrolls
  //     if (ticking) return;
  //     ticking = true;

  //     window.requestAnimationFrame(() => {
  //       // Clear previous timeout (debounce)
  //       if (scrollTimeout) clearTimeout(scrollTimeout);

  //       // Wait until user stops scrolling for 200ms
  //       scrollTimeout = setTimeout(() => {
  //         const scrollPosition = window.scrollY + 80; // offset for header, etc.
  //         let currentKey = null;

  //         Object.entries(sectionMap).forEach(([key, ref]) => {
  //           if (!ref.current) return;
  //           const sectionTop = ref.current.offsetTop;
  //           const sectionHeight = ref.current.offsetHeight;

  //           // Check if scroll is within this section
  //           if (
  //             scrollPosition >= sectionTop &&
  //             scrollPosition < sectionTop + sectionHeight
  //           ) {
  //             currentKey = key;
  //           }
  //         });

  //         // update nav only if different
  //         if (currentKey && currentKey !== activeSubKey) {
  //           setActiveSubKey(currentKey);
  //         }
  //       }, 200); // change nav only after 200ms of no scrolling

  //       ticking = false;
  //     });
  //   };

  //   window.addEventListener("scroll", handleScroll, { passive: true });

  //   // run once on mount
  //   handleScroll();

  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //     if (scrollTimeout) clearTimeout(scrollTimeout);
  //   };
  // }, [activeSubKey, setActiveSubKey]);

  // USEEFFECT FOR UPDATING LEFT NAVIGATION LINK ON SCROLL
  // +++++++++++++++++++++++++++++++++++++++++++++

  // commenting as of now due to org structure is not working properly
  // useEffect(() => {
  //   const tempExecutiveLeadershipTeam = getAllSubdimensionMatches(
  //     data,
  //     "Executive Leadership Team"
  //   );
  //   setExecutiveLeadershipTeam(tempExecutiveLeadershipTeam);

  //   const tempOrgChartData = getAllSubdimensionMatches(data, "Org Chart");
  //   const transformedOrgChartData = transformOrgChartData(tempOrgChartData);
  //   setOrgChartData(transformedOrgChartData);
  //   // console.log("TEMP ORG CHART DATA: " + JSON.stringify(tempOrgChartData));
  //   // console.log("ORG CHART DATA: " + JSON.stringify(transformedOrgChartData));

  //   const tempBusinessSegmentStructure = getAllSubdimensionMatches(
  //     data,
  //     "Business Segment"
  //   );
  //   setBusinessSegmentStructure(tempBusinessSegmentStructure);

  //   const tempStrategicLeadershipThemes = getAllSubdimensionMatches(
  //     data,
  //     "Strategic Themes"
  //   );
  //   setStrategicLeadershipThemes(tempStrategicLeadershipThemes);

  //   const tempFutureBets = getAllSubdimensionMatches(data, "Future Bets");
  //   setFutureBets(tempFutureBets);

  //   // console.log("CORP ORG: " + JSON.stringify(tempExecutiveLeadershipTeam));
  //   const { positive, negative, sowhat } = getCompProfilePageInsights(data);
  //   // console.log("POSITIVES: " + JSON.stringify(positive));
  //   setPagePositives(formatBoldText(positive) || []);
  //   setPageNegatives(formatBoldText(negative) || []);
  //   setPageSoWhat(formatBoldText(sowhat) || []);

  //   // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  //   // CODE TO MAKE TABS HIDDEN IF DATA NOT AVAILABLE
  //   setOrgStructureDataCheck((prevState) => ({
  //     ...prevState,
  //     hasExecutiveTimelineTabData: !!TIMELINE_DATA,
  //   }));

  //   dataReportCheck(
  //     "executiveTimelineTab",
  //     orgStructureDataCheck.hasExecutiveTimelineTabData
  //   );

  //   setOrgStructureDataCheck((prevState) => ({
  //     ...prevState,
  //     hasExecutiveLeadershipTeamTabData: !!tempExecutiveLeadershipTeam,
  //   }));

  //   dataReportCheck(
  //     "executiveLeadershipTeamTab",
  //     orgStructureDataCheck.hasExecutiveLeadershipTeamTabData
  //   );

  //   setOrgStructureDataCheck((prevState) => ({
  //     ...prevState,
  //     hasOrganizationalHierarchyTabData: !(orgChartData && companyData),
  //   }));

  //   dataReportCheck(
  //     "organizationalHierarchyTab",
  //     orgStructureDataCheck.hasOrganizationalHierarchyTabData
  //   );

  //   setOrgStructureDataCheck((prevState) => ({
  //     ...prevState,
  //     hasBusinessSegmentStructureTabData: !!businessSegmentStructure,
  //   }));

  //   dataReportCheck(
  //     "businessSegmentStructureTab",
  //     orgStructureDataCheck.hasBusinessSegmentStructureTabData
  //   );
  //   setOrgStructureDataCheck((prevState) => ({
  //     ...prevState,
  //     hasStrategicLeadershipThemesTabData: !!strategicLeadershipThemes,
  //   }));

  //   dataReportCheck(
  //     "strategicLeadershipThemesTab",
  //     orgStructureDataCheck.hasStrategicLeadershipThemesTabData
  //   );
  //   // CODE TO MAKE TABS HIDDEN IF DATA NOT AVAILABLE
  //   // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // }, [data]);

  useEffect(() => {
    const tempDynamicSubdimension = getAllDynamicSubdimensionMatches(data, [
      "Executive Leadership Team",
      "Org Chart",
      "Business Segment",
      "Strategic Themes",
      "Future Bets",
    ]);
    setDynamicSubdimension(tempDynamicSubdimension);

    const tempExecutiveLeadershipTeam = getAllSubdimensionMatches(
      data,
      "Executive Leadership Team"
    );
    setExecutiveLeadershipTeam(tempExecutiveLeadershipTeam);

    const tempOrgChartData = getAllSubdimensionMatches(data, "Org Chart");
    const transformedOrgChartData = transformOrgChartData(tempOrgChartData);
    setOrgChartData(transformedOrgChartData);

    // const tempBusinessSegmentStructure = getAllSubdimensionMatches(
    //   data,
    //   "Business Segment"
    // );
    // setBusinessSegmentStructure(tempBusinessSegmentStructure);

    // const tempStrategicLeadershipThemes = getAllSubdimensionMatches(
    //   data,
    //   "Strategic Themes"
    // );
    // setStrategicLeadershipThemes(tempStrategicLeadershipThemes);

    // const tempFutureBets = getAllSubdimensionMatches(data, "Future Bets");
    // setFutureBets(tempFutureBets);

    const { positive, negative, sowhat } = getCompProfilePageInsights(data);
    setPagePositives(formatBoldText(positive) || []);
    setPageNegatives(formatBoldText(negative) || []);
    setPageSoWhat(formatBoldText(sowhat) || []);

    const hasExecutiveTimeline = !!TIMELINE_DATA && TIMELINE_DATA.length > 0;
    const hasLeadershipTeam =
      !!tempExecutiveLeadershipTeam && tempExecutiveLeadershipTeam.length > 0;
    const hasOrgHierarchy = !!(transformedOrgChartData || companyData); // ✅ Show if EITHER exists
    // const hasBusinessSegment =
    //   !!tempBusinessSegmentStructure && tempBusinessSegmentStructure.length > 0;
    // const hasStrategicThemes =
    //   !!tempStrategicLeadershipThemes &&
    //   tempStrategicLeadershipThemes.length > 0;

    // Update state
    setOrgStructureDataCheck({
      hasExecutiveTimelineTabData: hasExecutiveTimeline,
      hasExecutiveLeadershipTeamTabData: hasLeadershipTeam,
      hasOrganizationalHierarchyTabData: hasOrgHierarchy,
      // hasBusinessSegmentStructureTabData: hasBusinessSegment,
      // hasStrategicLeadershipThemesTabData: hasStrategicThemes,
    });

    dataReportCheck("executiveTimelineTab", hasExecutiveTimeline);
    dataReportCheck("executiveLeadershipTeamTab", hasLeadershipTeam);
    dataReportCheck("organizationalHierarchyTab", hasOrgHierarchy);
    // dataReportCheck("businessSegmentStructureTab", hasBusinessSegment);
    // dataReportCheck("strategicLeadershipThemesTab", hasStrategicThemes);
  }, [data, companyData]);

  // const dummyContacts = [
  //   {
  //     company_name: "Tech Innovations Inc",
  //     first_name: "Alice",
  //     last_name: "Johnson",
  //     job_title: "Chief Executive Officer",
  //     management_level: "C-Level",
  //     direct_phone_number: "123-456-7890",
  //     mobile_phone: "987-654-3210",
  //     email_address: "alice.johnson@tech.com",
  //     person_city: "San Francisco",
  //     person_state: "CA",
  //     country: "USA",
  //     linkedin_contact_profile_url: "https://linkedin.com/in/alicejohnson",
  //   },
  //   {
  //     company_name: "Tech Innovations Inc",
  //     first_name: "Bob",
  //     last_name: "Smith",
  //     job_title: "VP of Engineering",
  //     management_level: "VP-Level",
  //     direct_phone_number: "555-222-1111",
  //     mobile_phone: "555-999-8888",
  //     email_address: "bob.smith@tech.com",
  //     person_city: "Austin",
  //     person_state: "TX",
  //     country: "USA",
  //     linkedin_contact_profile_url: "https://linkedin.com/in/bobsmith",
  //   },
  //   {
  //     company_name: "Tech Innovations Inc",
  //     first_name: "Charlie",
  //     last_name: "Brown",
  //     job_title: "Software Engineer",
  //     management_level: "Others",
  //     direct_phone_number: "444-555-6666",
  //     mobile_phone: "777-888-9999",
  //     email_address: "charlie.brown@tech.com",
  //     person_city: "New York",
  //     person_state: "NY",
  //     country: "USA",
  //     linkedin_contact_profile_url: "https://linkedin.com/in/charliebrown",
  //   },
  // ];

  // const dummyData = {
  //   id: "root",
  //   name: "TechNova Inc",
  //   type: "department",
  //   children: [
  //     {
  //       id: "eng",
  //       name: "Engineering",
  //       type: "department",
  //       children: [
  //         {
  //           id: "1",
  //           name: "Bob Smith",
  //           title: "VP of Engineering",
  //           type: "person",
  //         },
  //         {
  //           id: "2",
  //           name: "Carol Davis",
  //           title: "Senior Software Engineer",
  //           type: "person",
  //         },
  //       ],
  //     },
  //     {
  //       id: "exec",
  //       name: "Executive Leadership",
  //       type: "department",
  //       children: [
  //         {
  //           id: "3",
  //           name: "Alice Johnson",
  //           title: "Chief Executive Officer",
  //           type: "person",
  //         },
  //       ],
  //     },
  //     {
  //       id: "fin",
  //       name: "Finance",
  //       type: "department",
  //       children: [
  //         {
  //           id: "4",
  //           name: "David Miller",
  //           title: "Chief Financial Officer",
  //           type: "person",
  //         },
  //         {
  //           id: "5",
  //           name: "Eva Wilson",
  //           title: "Financial Analyst",
  //           type: "person",
  //         },
  //       ],
  //     },
  //     {
  //       id: "mkt",
  //       name: "Marketing",
  //       type: "department",
  //       children: [
  //         {
  //           id: "6",
  //           name: "Frank Taylor",
  //           title: "VP of Marketing",
  //           type: "person",
  //         },
  //         {
  //           id: "7",
  //           name: "Grace Lee",
  //           title: "Marketing Specialist",
  //           type: "person",
  //         },
  //         {
  //           id: "8",
  //           name: "Brett Warne",
  //           title: "Marketing Specialist",
  //           type: "person",
  //         },
  //       ],
  //     },
  //   ],
  // };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // HANDLE SCROLL FROM SEARCH (from parent via scrollTarget)
  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // useEffect(() => {
  //   if (!scrollTarget) return;

  //   // Don't scroll if data is still loading
  //   if (loading) {
  //     console.log("⏳ Waiting for data to load...");
  //     return;
  //   }

  //   const targetKey = scrollTarget.key;
  //   const sectionRef = sectionMap[targetKey];

  //   const scrollToSection = () => {
  //     if (!sectionRef?.current) {
  //       requestAnimationFrame(scrollToSection);
  //       return;
  //     }

  //     programmaticScrollRef.current = true;

  //     const yOffset = -100;
  //     const element = sectionRef.current;
  //     const y = element.getBoundingClientRect().top + window.scrollY + yOffset;

  //     window.scrollTo({ top: y, behavior: "smooth" });

  //     setTimeout(() => {
  //       programmaticScrollRef.current = false;
  //     }, 700);
  //   };

  //   // Give extra time for skeleton to disappear and content to render
  //   const timer = setTimeout(() => {
  //     requestAnimationFrame(scrollToSection);
  //   }, 1200); // Increase this if staticDataLoading timeout is 1000ms

  //   return () => clearTimeout(timer);
  // }, [scrollTarget, loading]); // ADD staticDataLoading to deps

  useEffect(() => {
    if (!scrollTarget || loading) return;

    const timer = setTimeout(() => {
      scrollToSection(scrollTarget.key);
    }, 900); // wait for skeleton + render

    return () => clearTimeout(timer);
  }, [scrollTarget, loading]);

  useEffect(() => {
    // trigger once after dynamic sections render
    if (dynamicSubdimension.length > 0) {
      const timer = setTimeout(() => {
        setDynamicReady((prev) => prev + 1);
      }, 0);

      return () => clearTimeout(timer);
    }
  }, [dynamicSubdimension]);

  // +++++++++++++++++++++++++++++++++++++++++++++++++

  return (
    <div className="org_wrapper">
      <div className="org_headblock">
        <div className="org_subheadblock">
          <h5 className="org_head">Org Structure & Leadership</h5>
          <p className="org_para">
            Leadership moves, structural shifts, and talent signals impacting
            strategic direction.
          </p>
        </div>
        <div className="org_btn_block">
          <TopRightActionLinks actions={actions} />
        </div>
      </div>
      {/* TIMELINE CHART */}
      {/* {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        <div className="table_head_block d-block" ref={executiveTimelineRef}>
          <div className="table_subblock_left">
            <h5 className="table_head">Executive Timeline</h5>
            <Timeline data={TIMELINE_DATA} filterColumn={"category"} />
          </div>
        </div>
      )} */}
      {/* {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        orgStructureDataCheck.hasExecutiveLeadershipTeamTabData && (
          <div ref={executiveLeadershipTeamRef}>
            <ExecutiveLeadershipTeam
              executiveLeadershipTeam={executiveLeadershipTeam}
            />
          </div>
        )
      )} */}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : subdimensionExists("Executive_Leadership_Team") &&
        subdimensionEnabled("Executive_Leadership_Team") &&
        orgStructureDataCheck.hasExecutiveLeadershipTeamTabData ? (
        <div ref={executiveLeadershipTeamRef}>
          <ExecutiveLeadershipTeam
            executiveLeadershipTeam={executiveLeadershipTeam}
          />
        </div>
      ) : null}

      {/* ++++++++++++++++++++++++++++++ */}
      {/* <div className="full-page">
        <OrgChartView companyData={companyData} onNewSearch={() => {}} />
      </div> */}
      {/* <div className="full-page">
        <OrgChartView companyData={companyData} onNewSearch={() => {}} />
      </div> */}
      {/* ++++++++++++++++++++++++++++++ */}
      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : subdimensionExists("Org_Chart") &&
        subdimensionEnabled("Org_Chart") &&
        orgStructureDataCheck.hasOrganizationalHierarchyTabData ? (
        <>
          <div className="table_head_block" ref={organizationalHierarchyRef}>
            <div className="table_subblock_left">
              <h5 className="table_head">Organizational Hierarchy</h5>
            </div>

            <div className="table_subblock_right">
              <div className="view-toggle">
                {companyData !== null && (
                  <>
                    <button
                      className={`hierarchy-button ${
                        viewMode === "hierarchy" ? "active" : ""
                      }`}
                      onClick={() => setViewMode("hierarchy")}
                    >
                      Hierarchy View
                    </button>

                    <button
                      className={viewMode === "leadership" ? "active" : ""}
                      onClick={() => setViewMode("leadership")}
                    >
                      Functional View
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>

          <div
            style={{
              backgroundColor: "#F8F8FB",
              marginBottom: "20px",
            }}
          >
            {viewMode === "hierarchy" && <OrgChartGiq data={orgChartData} />}

            {viewMode === "leadership" && (
              <div className="full-page">
                <OrgChartView
                  companyData={companyData}
                  onNewSearch={() => {}}
                />
              </div>
            )}
          </div>
        </>
      ) : null}

      {/* {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : subdimensionExists("Business_Segment") &&
        subdimensionEnabled("Business_Segment") &&
        orgStructureDataCheck.hasBusinessSegmentStructureTabData ? (
        <div ref={businessSegmentStructureRef}>
          <BusinessSegmentStructure
            businessSegmentStructure={businessSegmentStructure}
          />
        </div>
      ) : null} */}

      {/* {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : subdimensionExists("Strategic_Themes") &&
        subdimensionEnabled("Strategic_Themes") &&
        orgStructureDataCheck.hasStrategicLeadershipThemesTabData ? (
        <div ref={strategicLeadershipThemesRef}>
          <StrategicLeadershipThemes
            strategicLeadershipThemes={strategicLeadershipThemes}
          />
        </div>
      ) : null} */}

      {/* {dynamicSubdimension.map((item, index) => {
        const key = `dynamic_org_structure_${index}`;

        return (
          <div key={key} ref={(el) => (dynamicRefs.current[key] = el)}>
            <h5 className="mb-4">
              {item?.response?.subdimension_name}{" "}
              <span className="dynamic-subdimension-label">
                (User generated table)
              </span>
            </h5>

            <div
              className="table-responsive dynamic-subdimension"
              dangerouslySetInnerHTML={{
                __html: item?.response?.table,
              }}
            />
          </div>
        );
      })} */}

      {dynamicSubdimension.map((item, index) => {
        const key = `dynamic_org_structure_${index}`;
        const title = item?.response?.subdimension_name || "Dynamic Table";

        const actions = [
          {
            type: "download",
            title: "Export CSV",
            onClick: () => exportTableToCSV(dynamicRefs.current[key], title),
          },
        ];

        return (
          <div
            key={key}
            ref={(el) => {
              if (el) {
                dynamicRefs.current[key] = el;
              }
            }}
          >
            <div className="table_head_block mb-3" style={{ display: "flex" }}>
              <div className="table_subblock_left">
                <h5 className="table_head">
                  {title}
                  <span className="dynamic-subdimension-label">
                    (User generated table)
                  </span>
                </h5>
              </div>
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "end",
                }}
              >
                <TopRightActionLinks actions={actions} />
              </div>
            </div>

            <div
              className="table-responsive dynamic-subdimension"
              dangerouslySetInnerHTML={{
                __html: item?.response?.table,
              }}
            />
          </div>
        );
      })}

      {/* MOVED FUTURE BETS TO FINANCIALS TAB */}
      {/* {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        <div ref={futureBetsLeadershipLedInitiativesRef}>
          <FutureBets futureBets={futureBets?.[0]?.response?.fields || {}} />
        </div>
      )} */}
      {/* <div className="future_bets_wrapper mb-2">
        <div className="future_bets_headblock">
          <div className="future_bets_subheadblock">
            <h5 className="future_bets_head">
              Future Bets & Leadership-Led Initiatives
            </h5>
          </div>
          <div className="future_bets_btn_block">
            <TopRightActionLinks actions={actions} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="future_bets_subblock">
              <h5 className="future_bets_head">Autonomous Supply Chain</h5>
              <p className="future_bets_para">
                Steve Miller, COO is leading AI-driven forecasting and automated
                distribution centers.
              </p>
            </div>
          </div>
          <div className="col-md-6">
            <div className="future_bets_subblock">
              <h5 className="future_bets_head">Autonomous Supply Chain</h5>
              <p className="future_bets_para">
                Steve Miller, COO is leading AI-driven forecasting and automated
                distribution centers.
              </p>
            </div>
          </div>
          <div className="col-md-6">
            <div className="future_bets_subblock">
              <h5 className="future_bets_head">Autonomous Supply Chain</h5>
              <p className="future_bets_para">
                Steve Miller, COO is leading AI-driven forecasting and automated
                distribution centers.
              </p>
            </div>
          </div>
          <div className="col-md-6">
            <div className="future_bets_subblock">
              <h5 className="future_bets_head">Autonomous Supply Chain</h5>
              <p className="future_bets_para">
                Steve Miller, COO is leading AI-driven forecasting and automated
                distribution centers.
              </p>
            </div>
          </div>
        </div>
      </div> */}
      {showScrollTop && (
        <button className="scroll-top-btn" onClick={scrollToTop}>
          {/* ↑ */}
          <FeatherIcon.ChevronUp />
        </button>
      )}

      {showConversationModal && (
        <GenericOverviewSideCard
          showMoreModal={showConversationModal}
          setShowMoreModal={setShowConversationModal}
          titleForSideCard={
            <div className="ai_insight_top_block">
              <div className="ai_insight_left">
                <div className="ai_insight_img">
                  <img
                    src="/img/ai_insight_top.png"
                    alt="icon"
                    className="ai_icon"
                  />
                </div>
                <div className="ai_insight_text">
                  <h5 className="ai_insight_top_head">
                    Decode This:{" "}
                    {competitorName ?? "Tailored Chemical Products"} - Market
                    Insights
                  </h5>
                  <p className="ai_insight_top_subhead">
                    AI-powered competitive intelligence and strategic insights
                  </p>
                </div>
              </div>
              <div className="ai_insight_right"></div>
            </div>
          }
          comp={<AIChat section={""} />}
          minWidthForDrawer="40%"
          disableXbtn={false}
        />
      )}
    </div>
  );
}

export default OrgStructure;
